import { FC, useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";

import Loader from "@app/components/Loader";
import VersionManagementContainer from "@app/containers/versionManagement";
import { RoutePaths } from "@app/routes/index";
import { getVersionByID } from "@app/services/Endpoints/VersionControl.API";
import { VersionControlData } from "@app/types/VersionControl";

const EditVersionManagementPage: FC = () => {
    const location = useLocation();
    const navigate = useNavigate();

    const [version, setVersion] = useState<VersionControlData | null>(null);
    const [loader, setLoader] = useState<boolean>(false);

    useEffect(() => {
        const installationId = location.state?.InstallationId;

        if (!installationId) {
            navigate(RoutePaths.ViewVersionManagement);
            return;
        }

        let isMounted = true;
        setLoader(true);

        getVersionByID(installationId)
            .then((res) => {
                if (isMounted) {
                    setVersion(res?.data?.data ?? null);
                }
            })
            .catch((err) => {
                console.error(err);
            })
            .finally(() => {
                if (isMounted) {
                    setLoader(false);
                }
            });

        return () => {
            isMounted = false;
        };
    }, [location.state, navigate]);

    if (loader) {
        return <Loader data-testid="loader" />;
    }

    if (!version) {
        return null;
    }

    return <VersionManagementContainer version={version} />;
};

export default EditVersionManagementPage;
